import { DocumentData, Timestamp, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions } from "firebase/firestore";
import { vxm } from "@/store";

export default interface Team {
  id: string;
  rank: number;
  name: string;
  color: string;
  totalScore: number;
  totalAnswers: number;
  correctAnswers: number;
  incorrectAnswers: number;
  hints: number;
  isFinished: boolean;
  startTime?: Timestamp;
  finishTime?: Timestamp;
  time: number;
  odometer: number;
  members: string[];
}

export class TeamConverter implements FirestoreDataConverter<Team> {
  toFirestore(team: Team): DocumentData {
    return team;
  }

  fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): Team {
    const team = {
      id: snapshot.id,
      ...snapshot.data(options)
    } as Team;

    team.totalAnswers = team.correctAnswers + team.incorrectAnswers;

    if (team.startTime && team.finishTime) {
      team.time = team.finishTime.toMillis() / 1000 - team.startTime.toMillis() / 1000;
    } else if (team.startTime) {
      team.time = Date.now() / 1000 - team.startTime.toMillis() / 1000;
    }

    return Object.freeze(team);
  }
}

// Distance filter
export function distance(odometer: number) {
  if (vxm.results.game.units === "metric") {
    return Math.round(odometer * 100) / 100;
  }

  return Math.round(odometer * 0.621371 * 100) / 100;
}

// Date filter
export function timeConvert(timestamp: Timestamp) {
  if (!timestamp) {
    return "";
  }

  const date = timestamp.toDate();
  const year = date.getFullYear();
  const month = date.getMonth();
  const monthFilter = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const day = date.getDate();
  const hour = date.getHours();
  const min = date.getMinutes();

  if (min < 10) {
    return monthFilter[month] + " " + day + ", " + year + " at " + hour + ":0" + min;
  } else {
    return monthFilter[month] + " " + day + ", " + year + " at " + hour + ":" + min;
  }
}

// Time spent filter
export function timeSpent(s: number) {
  if (!s) {
    return "";
  }

  const m = Math.floor(s / 60);
  const h = Math.floor(s / 3600);
  const d = Math.floor(s / 86400);

  if (s < 60) {
    return Math.round(s) + "s";
  } else if (s < 3600) {
    return m + "m " + Math.floor(s - m * 60) + "s";
  } else if (s < 86400) {
    return h + "h " + Math.floor((s - h * 3600) / 60) + "m " + Math.floor(s - m * 60) + "s";
  } else {
    return d + "d " + Math.floor((s - d * 86400) / 3600) + "h " + Math.floor((s - h * 3600) / 60) + "m " + Math.floor(s - m * 60) + "s";
  }
}

// Excel duration filter
export function sheetsDuration(seconds: number) {
  if (!seconds) {
    return "";
  }

  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds) % 60;

  return `${h}:${m < 10 ? `0${m}` : m}:${s < 10 ? `0${s}` : s}`;
}
